import type { FrontendErrorEvent } from './types';

const INGEST_PATH = '/monitoring/frontend-error';

export async function reportFrontendError(event: FrontendErrorEvent): Promise<void> {
  const payload = {
    ...event,
    environment: window.__APP_ENVIRONMENT__ ?? 'unknown',
    release: window.__APP_RELEASE__ ?? 'unknown',
    timestamp: new Date().toISOString(),
  };

  try {
    await fetch(INGEST_PATH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Swallow: if the ingest endpoint itself is unreachable we cannot do
    // much from the browser. Logging here would just create noise that
    // never leaves the page.
  }
}
